<template>
  <div class="document-item" :class="{ gray }">
    <div
      class="name-column"
      :class="{ 'download-link': item.folder_type, pointer: actions === 'modal' && item.extension !== 'folder' }"
      @click="clickHandler"
    >
      <div class="file-icon" :class="iconType" />
      {{ item.name || item.title }}
    </div>
    <FileLink
      v-if="item.old_name"
      class="file-column"
      :link="'documents/download/?id=' + (item.document_id || item.id)"
      :name="item.old_name || item.name"
    />
    <div v-else class="file-column">{{ item.name }}</div>
    <div class="category-column">{{ item.text }}</div>
    <div class="date-column">
      <template v-if="item.upload_date">
        {{ $helper.makeDate(new Date(Number.parseInt(item.upload_date))) }}
      </template>
      <template v-else>–</template>
    </div>
    <div v-if="folder_type !== 'public'" class="events-column">
      <template v-if="actions === 'main' && item.extension !== 'folder'">
        <div v-if="!item.protected" class="green-edit-icon icon pointer" @click="openEditModal" />
        <div v-if="!item.protected" class="red-christ-icon icon pointer" @click="openDeleteModal" />
      </template>
      <template v-if="actions === 'modal' && item.extension !== 'folder'">
        <div class="download-link" @click="clickHandler">Выбрать</div>
      </template>
    </div>
    <div v-else-if="$store.getters.isSuperAdmin" class="events-column">
      <div class="red-christ-icon icon pointer" @click="openDeleteModal" />
    </div>
    <div v-else class="events-column">
      <template v-if="item.object">{{ item.object }}</template>
    </div>
    <ModalWindow v-if="openEditFile" header="Редактировать документ" @close-handler="openEditFile = false">
      <EditDocument :file="item" />
    </ModalWindow>
    <ModalWindow v-if="openDeleteFile" header="Удалить документ" @close-handler="openDeleteFile = false">
      <DeleteDocument :file="item" :type="type" :document-id="documentId" @delete-document="deleteDocument" />
    </ModalWindow>
  </div>
</template>

<script>
import ModalWindow from '@/components/widgets/custom-components/modalWindow/modalWindow'
import EditDocument from '@/components/widgets/custom-components/modalWindow/modalComponents/editDocument'
import DeleteDocument from '@/components/widgets/custom-components/modalWindow/modalComponents/deleteDocument'
import FileLink from '@/components/common/FileLink'

export default {
  name: 'FileManagerItem',
  components: { FileLink, ModalWindow, EditDocument, DeleteDocument },
  props: {
    actions: {
      default() {
        return 'main'
      }
    },
    folder_type: {
      default() {
        return 'personal'
      }
    },
    object: {
      default() {
        return ''
      }
    },
    gray: {
      default() {
        return true
      }
    },
    documentId: {
      default() {
        return false
      }
    },
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      openEditFile: false,
      openDeleteFile: false,
      iconType: '',
      icons: {
        audio: ['mp3', 'wav', 'wma'],
        video: ['mp4', 'mpeg4', 'wmv'],
        image: ['jpg', 'jpeg', 'png'],
        doc: ['doc', 'docx', 'txt'],
        pdf: ['pdf']
      }
    }
  },
  mounted() {
    this.makeIcon(this.item.extension)
  },
  methods: {
    makeIcon(extension) {
      for (let item in this.icons) {
        this.icons[item].find((ext) => {
          if (ext === extension) {
            this.iconType = item
          }
        })
      }
      if (extension === 'folder') {
        this.iconType = 'folder'
      }
    },
    clickHandler() {
      this.$emit('clickHandler')
    },
    deleteDocument() {
      this.$emit('deleteDocument')
    },
    openEditModal() {
      this.openEditFile = true
    },
    openDeleteModal() {
      this.openDeleteFile = true
    }
  }
}
</script>
<style scoped>
.file-icon.folder {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23000000' viewBox='0 0 16 16' width='32px' height='32px'%3E%3Cpath d='M 2.5 2 C 1.675781 2 1 2.675781 1 3.5 L 1 12.5 C 1 13.324219 1.675781 14 2.5 14 L 13.5 14 C 14.324219 14 15 13.324219 15 12.5 L 15 5.5 C 15 4.675781 14.324219 4 13.5 4 L 6.796875 4 L 6.144531 2.789063 C 5.882813 2.300781 5.375 2 4.824219 2 Z M 2.5 3 L 4.824219 3 C 5.007813 3 5.175781 3.101563 5.265625 3.261719 L 5.664063 4 L 2 4 L 2 3.5 C 2 3.21875 2.21875 3 2.5 3 Z M 2 5 L 13.5 5 C 13.78125 5 14 5.21875 14 5.5 L 14 12.5 C 14 12.78125 13.78125 13 13.5 13 L 2.5 13 C 2.21875 13 2 12.78125 2 12.5 Z'/%3E%3C/svg%3E");
}
.file-icon {
  margin-right: 10px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Layer_2' x='0px' y='0px' width='20px' height='20px' viewBox='-909 226 100 100' style='enable-background:new -909 226 100 100;' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M-823.7,226.7H-894c-1.1,0-2,0.9-2,2v64.7c0,0.3,0.1,0.5,0.3,0.7l32,30.9c0.2,0.2,0.4,0.3,0.7,0.3h39.3c1.1,0,2-0.9,2-2 v-94.6C-821.7,227.6-822.6,226.7-823.7,226.7z M-864.9,316.9l-22.4-21.7h22c0.3,0,0.5,0.2,0.5,0.5L-864.9,316.9L-864.9,316.9z M-826.7,320.3h-33.2v-28c0-1.1-0.9-2-2-2H-891v-58.6h64.3V320.3z'/%3E%3C/g%3E%3C/svg%3E");
  background-position: center;
  background-size: contain;
  width: 30px;
  height: 30px;
  flex: none;
  background-repeat: no-repeat;
}
.download-link:hover {
  text-decoration: underline;
}

.download-link {
  color: #1cc8ab;
  cursor: pointer;
}

.red-christ-icon {
  width: 12px;
  height: 12px;
}

.green-edit-icon {
  width: 12px;
  height: 12px;
}

.document-item {
  display: flex;
  border: 1px solid #cccccc;
}

.events-column {
  padding-right: 20px;
  border-right: 1px solid #cccccc;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 160px;
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  flex: none;
}

.category-column {
  border-right: 1px solid #cccccc;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 250px;
  padding-left: 20px;
  flex: none;
}

.file-column {
  border-right: 1px solid #cccccc;
  word-break: break-word;
  padding-top: 10px;
  padding-bottom: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 250px;
  flex: none;
  padding-left: 20px;
}

.name-column {
  display: flex;
  border-right: 1px solid #cccccc;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
  padding-left: 20px;
  border-left: 1px solid #cccccc;
}

.date-column {
  width: 200px;
  border-right: 1px solid #cccccc;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  flex: none;
}
</style>

<style scoped>
/*Иконки */
.pdf {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' width='32px' height='32px' viewBox='0 0 612 612' style='enable-background:new 0 0 612 612;' xml:space='preserve'%3E%3Cg%3E%3Cg%3E%3Cpath d='M544.103,223.429H480.96v-170C480.96,23.47,454.042,0,424.977,0H182.12c-4.197,0-7.228,1.855-9.889,4.993 c-1.137,0.729-2.244,1.516-3.05,2.517L22.038,190.002c-1.467,1.807-2.312,3.925-2.788,6.12l-3.419,4.274 c-2.089,2.584-1.156,5.799-1.156,9.131v349.044c0,28.958,21.051,53.429,50.874,53.429h359.428 c29.065,0,55.984-23.47,55.984-53.429V417.715h63.143c29.512,0,53.429-23.927,53.429-53.43v-87.428 C597.532,247.355,573.616,223.429,544.103,223.429z M568.389,364.285c0,13.416-10.87,24.286-24.286,24.286H359.532 c-13.415,0-24.285-10.87-24.285-24.286v-87.428c0-13.416,10.87-24.286,24.285-24.286h184.571c13.416,0,24.286,10.87,24.286,24.286 V364.285z M170.103,57.945v97.668c0,13.531-19.011,28.958-32.047,28.958H67.394l49.436-63.134L170.103,57.945z M451.818,558.571 c0,13.843-13.901,24.286-26.841,24.286H65.548c-13.784,0-21.73-11.347-21.73-24.286V214.676l0.758-0.961h93.48 c29.327,0,61.19-28.23,61.19-58.102V29.143h225.731c12.939,0,26.84,10.443,26.84,24.286v170h-92.285 c-29.512,0-53.429,23.927-53.429,53.429v87.428c0,29.503,23.917,53.43,53.429,53.43h92.285L451.818,558.571L451.818,558.571z'/%3E%3Cpath d='M413.796,310.954c-2.069-1.846-4.527-3.147-7.374-3.954c-2.885-0.815-6.994-1.224-12.327-1.224h-18.078 c-3.099,0-5.362,0.661-6.78,1.991c-1.429,1.321-2.138,3.546-2.138,6.635v53.604c0,2.788,0.651,4.896,1.943,6.334 c1.292,1.447,3.002,2.166,5.129,2.166c2.021,0,3.701-0.738,5.022-2.186c1.331-1.457,1.991-3.584,1.991-6.411v-19.672h12.91 c8.626,0,15.125-1.846,19.487-5.488c4.371-3.662,6.547-9.015,6.547-16.106c0-3.322-0.534-6.295-1.612-8.956 C417.439,315.034,415.875,312.771,413.796,310.954z M404.101,333.151c-1.176,1.573-2.876,2.71-5.109,3.41 c-2.225,0.689-4.993,1.049-8.315,1.049h-9.491v-21.255h9.491c6.285,0,10.442,1.03,12.473,3.08c1.807,1.933,2.7,4.439,2.7,7.489 C405.85,329.489,405.267,331.559,404.101,333.151z'/%3E%3Cpath d='M480.562,312.091c-2.788-2.448-5.887-4.099-9.296-4.993c-3.42-0.874-7.52-1.32-12.289-1.32h-18.351 c-3.04,0-5.245,0.68-6.596,2.039c-1.37,1.351-2.04,3.556-2.04,6.587v51c0,2.243,0.194,4.061,0.583,5.469 c0.398,1.418,1.243,2.497,2.545,3.283c1.292,0.777,3.225,1.156,5.79,1.156h18.35c3.196,0,6.071-0.214,8.607-0.612 c2.555-0.417,4.925-1.117,7.149-2.137c2.205-1.01,4.245-2.36,6.11-4.031c2.38-2.176,4.323-4.663,5.838-7.432 c1.516-2.749,2.643-5.867,3.371-9.316c0.719-3.439,1.088-7.247,1.088-11.424C491.422,327.702,487.799,318.279,480.562,312.091z M470.081,360.847c-1.049,0.913-2.283,1.632-3.701,2.128c-1.428,0.515-2.798,0.835-4.129,0.951 c-1.33,0.137-3.167,0.186-5.498,0.186h-10.676v-47.183h9.297c4.293,0,7.966,0.456,11.006,1.39 c3.031,0.941,5.586,3.108,7.655,6.518c2.078,3.42,3.108,8.559,3.108,15.427C477.143,349.996,474.782,356.864,470.081,360.847z'/%3E%3Cpath d='M545.357,305.776h-33.204c-1.991,0-3.633,0.302-4.915,0.864c-1.282,0.593-2.215,1.525-2.817,2.808 c-0.612,1.272-0.903,2.943-0.903,4.954v53.507c0,2.885,0.66,5.032,1.962,6.45c1.321,1.428,3.021,2.146,5.11,2.146 c2.05,0,3.73-0.709,5.041-2.127c1.321-1.408,1.973-3.546,1.973-6.47v-22.896H540.8c2.118,0,3.711-0.476,4.789-1.428 s1.613-2.234,1.613-3.847c0-1.613-0.525-2.905-1.594-3.876c-1.049-0.942-2.661-1.438-4.809-1.438h-23.197v-17.776h27.754 c2.233,0,3.904-0.515,4.993-1.506c1.098-1.001,1.642-2.312,1.642-3.964c0-1.612-0.544-2.924-1.642-3.904 C549.261,306.263,547.59,305.776,545.357,305.776z'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E");
}
.image {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' height='24' viewBox='0 0 24 24' width='24'%3E%3Cpath clip-rule='evenodd' d='M20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5ZM4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4Z' fill='black' fill-rule='evenodd'/%3E%3Cpath clip-rule='evenodd' d='M16.8542 9.56127C16.6588 9.36589 16.342 9.36603 16.1468 9.56158L11.1833 14.5336C10.5942 15.1238 9.63679 15.1202 9.05214 14.5255L8.1123 13.5697C7.91754 13.3716 7.59864 13.3702 7.40221 13.5667L2.85356 18.1153C2.6583 18.3106 2.34172 18.3106 2.14646 18.1153C1.95119 17.9201 1.95119 17.6035 2.14646 17.4082L6.69511 12.8596C7.2844 12.2703 8.24107 12.2743 8.82536 12.8686L9.76521 13.8244C9.96009 14.0227 10.2792 14.0239 10.4756 13.8271L15.439 8.85508C16.0247 8.26843 16.9751 8.26802 17.5613 8.85417L21.8536 13.1464C22.0488 13.3417 22.0488 13.6583 21.8536 13.8536C21.6583 14.0488 21.3417 14.0488 21.1465 13.8536L16.8542 9.56127Z' fill='black' fill-rule='evenodd'/%3E%3Cpath clip-rule='evenodd' d='M6.21053 9C6.79188 9 7.26316 8.55228 7.26316 8C7.26316 7.44772 6.79188 7 6.21053 7C5.62917 7 5.15789 7.44772 5.15789 8C5.15789 8.55228 5.62917 9 6.21053 9Z' fill='black' fill-rule='evenodd'/%3E%3C/svg%3E");
}
</style>
